import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';






import { EmicardGeolocationComponent } from './emicard-geolocation/emicard-geolocation.component';
import { ExistingCustCardComponent } from './existing-cust-card/existing-cust-card.component';
import { ManagecardComponent } from './managecard/managecard.component';
import { MfiScreenComponent } from './mfi-screen/mfi-screen.component';
import { NewCustCardComponent } from './new-cust-card/new-cust-card.component';
import { QrlandingHomeComponent } from './qrlanding-home/qrlanding-home.component';
import { SelectcardComponent } from './selectcard/selectcard.component';
import { ShopOnlineComponent } from './shop-online/shop-online.component';
import { DealerDetailsComponent } from './dealer-details/dealer-details.component';
import { DealerLocatorComponent } from './dealer-locator/dealer-locator.component';
import { DealersComponent } from './dealers/dealers.component';
import { ThankYouPageComponent } from './thank-you-page/thank-you-page.component';
import { ShopOnlineHomeComponent } from './shop-online-home/shop-online-home.component';
import { ShopOnlineBrandsComponent } from './shop-online-brands/shop-online-brands.component';
import { HelperScreenComponent } from './helper-screen/helper-screen.component';
import { EmandataScreenComponent } from './emandata-screen/emandata-screen.component';




const routes: Routes = [
 // { path: '',  pathMatch: 'full', component: HomeComponent},
//{ path: 'home',  pathMatch: 'full' , component: HomeComponent},


{ path: 'geolocation', component : EmicardGeolocationComponent},
{path: 'managecard',component:ManagecardComponent},
{path:'selectcard',component:SelectcardComponent},
{path:'shoponline',component:ShopOnlineComponent},
{path:'mfi-screen',component:MfiScreenComponent},
{path:'qr-landing-page',component:QrlandingHomeComponent},
{path:'existing-customer',component:ExistingCustCardComponent},
{path:'new-customer',component:NewCustCardComponent},
{path:'dealers',component:DealersComponent},
{path:'dealer-details',component:DealerDetailsComponent},
{path:'dealer-locator',component:DealerLocatorComponent},
{path:'thank-you',component:ThankYouPageComponent},
{path:'shop-online-home',component:ShopOnlineHomeComponent},
{path:'shop-online-brands',component:ShopOnlineBrandsComponent},
{path:'helper-screen',component:HelperScreenComponent},
{path:'emandata-screen',component:EmandataScreenComponent}



];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { 


}
